import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { IFilter } from '../../common/interfaces/IFilter';
import styles from './styles.module.scss';

export const FilterSelect = ({
  filterName,
  options,
  selected,
  onChange,
}: {
  filterName: string;
  options: IFilter[];
  selected: IFilter[];
  onChange: (event: SelectChangeEvent<IFilter[]>) => void;
}) => {
  return (
    <Select
      multiple
      displayEmpty
      value={selected}
      onChange={onChange}
      sx={{ fontSize: '14.75px' }}
      className={`${styles.FilterSelect} ${
        selected?.length ? styles.HasFilter : ''
      }`}
      renderValue={selectedFilters => {
        if (!selectedFilters?.length) {
          return <div className={styles.FilterPlaceholder}>{filterName}</div>;
        }
        if (selectedFilters.length === 1) {
          return (
            <div className={styles.SelectedFilters}>
              {selectedFilters[0].label}
            </div>
          );
        }
        return (
          <div className={styles.SelectedFilters}>
            {filterName}{' '}
            <span className={styles.SelectedFiltersTotal}>
              {selectedFilters.length}
            </span>
          </div>
        );
      }}
      inputProps={{ 'aria-label': 'Without label' }}
    >
      {options.map((d: any) => (
        <MenuItem key={d.label} value={d} sx={{ fontSize: '14.75px' }}>
          {selected?.some(
            selectedFilter => selectedFilter.value === d.value,
          ) && <CheckIcon fontSize={'small'} sx={{ mr: 1 }} />}
          {d.label}
        </MenuItem>
      ))}
    </Select>
  );
};
